import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Auth from "@/components/Auth.vue";
import UiKitView from "@/views/UiKitView.vue";
import AccountView from "@/views/AccountView.vue";
import TariffView from "@/views/TariffView.vue";
import FAQViews from "@/views/FAQViews.vue";
import { getTokenFromCookies } from "@/utils/common";
import AddonsView from "@/views/AddonsView.vue";
import SettingsView from "@/views/SettingsView.vue";
import PaymentView from "@/views/PaymentView.vue";
import RoamingView from "@/views/RoamingView.vue";
import PremiumPhonesView from "@/views/PremiumPhonesView.vue";
import HistoryPage from "@/components/history/HistoryPage.vue";
import FeedbackView from "@/views/FeedbackView.vue";
import SupportView from "@/views/SupportView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: Auth,
    meta: {
      requiresAuth: false,
      layout: "auth-layout",
    },
  },
  {
    path: "/ui-kit",
    name: "ui-kit",
    component: UiKitView,
    meta: {
      requiresAuth: false,
      layout: "auth-layout",
    },
  },
  {
    path: "/roaming",
    name: "roaming",
    component: RoamingView,
    meta: {
      requiresAuth: true,
      layout: "main-layout",
    },
  },
  {
    path: "/account",
    name: "account",
    component: AccountView,
    meta: {
      requiresAuth: true,
      layout: "main-layout",
    },
  },
  {
    path: "/tariff",
    name: "tariff",
    component: TariffView,
    meta: {
      requiresAuth: true,
      layout: "main-layout",
    },
  },
  {
    path: "/addons",
    name: "addons",
    component: AddonsView,
    meta: {
      requiresAuth: true,
      layout: "main-layout",
    },
  },
  {
    path: "/faq",
    name: "faq",
    component: FAQViews,
    meta: {
      requiresAuth: true,
      layout: "main-layout",
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: SettingsView,
    meta: {
      requiresAuth: true,
      layout: "main-layout",
    },
  },
  {
    path: "/payment",
    name: "payment",
    component: PaymentView,
    meta: {
      requiresAuth: true,
      layout: "main-layout",
    },
  },
  {
    path: "/premium",
    name: "premium",
    component: PremiumPhonesView,
    meta: { requiresAuth: true },
  },
  {
    path: "/history",
    name: "history",
    component: HistoryPage,
    meta: {
      requiresAuth: true,
      layout: "main-layout",
    },
  },
  {
    path: "/feedback",
    name: "feedback",
    component: FeedbackView,
    meta: { requiresAuth: true },
  },
  {
    path: "/support",
    name: "support",
    component: SupportView,
    meta: {
      requiresAuth: true,
      layout: "main-layout",
    },
  },
  {
    path: "/:catchAll(.*)", // This will match any path not explicitly defined
    redirect: "/", // Redirect to the home page
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = checkAuth();

  if (to.meta.requiresAuth && !isAuthenticated) {
    console.log("unauthorized");
    next("/");
  } else {
    next();
  }
});

const checkAuth = () => {
  return !!getTokenFromCookies();
};

export default router;
